import type { SVGProps } from 'react';
const DawnFlagBN = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-BN_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-BN_svg__a)">
      <path fill="#F7E250" d="M0 0h22v16H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M-3.275 2.678 25.288 13.29l1.061-2.975L-2.214-.297z"
        clipRule="evenodd"
      />
      <path
        fill="#262626"
        fillRule="evenodd"
        d="m-4.35 5.685 28.563 10.612 1.06-2.975L-3.288 2.71z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagBN;
